import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import PermissionInitializer from "./PermissionInitializer";
import FeatureFlagDebugger from "../_features/featureFlags/devtools/FeatureFlagDebugger";
import FeatureFlagInitializer from "../_features/featureFlags/bootstrap/FeatureFlagInitializer";
import RouteFallback from "../_components/loaders/RouteFallback";
import OfflineBanner from "../_components/ui/OfflineBanner";
import ModalHost from "../_app/entityModals/ModalHost";

// No `key={location.pathname}` on this Outlet - AppLayout and SettingsLayout
// (both rendered through it) each own persistent state that must survive
// in-layout navigation: SideNav, useBootstrapAppData's mount-time fetch, and
// (via the nav's dev-tools menu) a second permissions subscription. Keying
// this top-level Outlet by pathname used to force a full unmount/remount of
// that entire shell on every single route change, not just real layout
// switches - refiring both fetches on every click. Per-page transition
// animation now lives inside AppLayout/SettingsLayout's own inner Outlet
// instead, where it only affects the page content, not the shell around it.
const RootLayout = () => {
  return (
    <>
      <OfflineBanner />
      <PermissionInitializer />
      <FeatureFlagInitializer />
      <FeatureFlagDebugger />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <ModalHost />
    </>
  );
};

export default RootLayout;
